/** Haversine distance dalam meter — mirror dari apps/api/src/lib/geo.ts */
export function haversineDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371000;
    const toRad = (deg: number) => (deg * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

export function findNearestOffice<T extends { lat: number; lng: number }>(
    offices: readonly T[],
    lat: number,
    lng: number,
): { office: T | null; distance: number } {
    let nearest: T | null = null;
    let nearestDist = Infinity;
    for (const o of offices) {
        const d = haversineDistance(lat, lng, o.lat, o.lng);
        if (d < nearestDist) { nearestDist = d; nearest = o; }
    }
    return { office: nearest, distance: nearest ? nearestDist : Infinity };
}
